import { callable } from './functions';

export const getMyCalendarFeedUrl = callable<{ orgId: string }, { url: string }>('getMyCalendarFeedUrl');

export const regenerateMyCalendarFeedUrl = callable<{ orgId: string }, { url: string }>(
  'regenerateMyCalendarFeedUrl',
);
